import { TimeRange } from '@nirvana/shared/dtos/types/shared/time';
import { ColumnDetails } from '../../types/common';
import { GridFilterUiConfiguration } from '../../../types/filters/types';

export interface Regex {
  pattern: string;
  options?: string;
}

export interface StringConditions {
  equals?: string;
  in?: Array<string>;
  contains?: string;
  regex?: Regex;
  startsWith?: string;
}

export interface IntConditions {
  equals?: number;
  in?: Array<number>;
  greaterThan?: number;
  lowerThan?: number;
  greaterThanOrEqual?: number;
  lowerThanOrEqual?: number;
}

export interface DoubleConditions {
  equals?: number;
  in?: Array<number>;
  greaterThan?: number;
  lowerThan?: number;
  greaterThanOrEqual?: number;
  lowerThanOrEqual?: number;
}

export interface DateConditions {
  timeRange?: TimeRange;
}

export interface IntEnumConditions {
  in: Array<number>;
}

export type Filter<ColumnKeys extends string> = {
  [columnKey in ColumnKeys]?: any;
};

export interface GridFiltersViewData<Column extends number, ColumnKeys extends string> {
  columnDetailsByKey: { [key: string]: ColumnDetails<Column, ColumnKeys> };
  filters: Array<Filter<ColumnKeys>>;
  predefinedFiltersKeys: Array<ColumnKeys>;
  companyFilterDataProvider?: string;
  filtersUiConfigs?: Array<GridFilterUiConfiguration>;
  hideResetFilters?: boolean;
}

export enum FilterChangeEvents {
  REMOTE_SELECT_CHANGED = 'remote-select-changed',
}

export enum GridFilterRenderEvents {
  FILTERS_RENDER_DONE = 'filters-render-done',
}
